export function isEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}
export function setDifference(setA, setB) {
    const _difference = new Set([...setA]);
    for (const elem of setB) {
        _difference.delete(elem);
    }
    return _difference;
}
export function arrayDifference(a, b) {
    const _difference = [];
    for (let i = 0; i < a.length; i++) {
        const v = a[i];
        if (!b.includes(v)) {
            _difference.push(v);
        }
    }
    return _difference;
}
